import styled from 'styled-components';
import { IonPage } from '@ionic/react';

export const MockScreenPage = styled(IonPage)`
  .content {
  }
`;
